import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

const MOBILE_BREAKPOINT = 767;

class TktWidgetB2B implements Plugin {
  private panel: HTMLElement | null = null;
  private categoriesButton: HTMLElement | null = null;
  private resizeObserver: ResizeObserver | null = null;
  private isMobile: boolean | null = null;

  private toggleCategoriesHandler = () => {
    this.setPanelOpen(!this.isPanelOpen());
  };

  private closePanelHandler = (event: Event) => {
    const target = (event.target as HTMLElement).closest<HTMLElement>(
      '[data-action="close-panel"]',
    );
    if (!target || !this.element.contains(target)) return;
    this.setPanelOpen(false);
  };

  // El breakpoint depende del ancho del propio widget (@container en
  // TktWidgetB2B.scss), no del viewport: puede vivir en una columna
  // estrecha (sidebar de checkout) con el navegador en desktop.
  private readonly syncToWidth = ([entry]: ResizeObserverEntry[]) => {
    const width = entry.contentRect.width;
    const isMobile = width <= MOBILE_BREAKPOINT;
    if (isMobile === this.isMobile) return;

    this.isMobile = isMobile;
    this.setPanelOpen(!isMobile);
  };

  constructor(private element: HTMLElement) {}

  private isPanelOpen(): boolean {
    return !this.element.classList.contains("tkt-widgetB2B--no-panel");
  }

  private setPanelOpen(open: boolean): void {
    if (!this.panel) return;
    this.element.classList.toggle("tkt-widgetB2B--no-panel", !open);
    this.categoriesButton?.setAttribute("aria-expanded", String(open));
  }

  init(): void {
    this.panel = this.element.querySelector<HTMLElement>(
      ".tkt-widgetB2B__panel",
    );
    this.categoriesButton = this.element.querySelector<HTMLElement>(
      '[data-action="categories"]',
    );

    if (this.panel && typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(this.syncToWidth);
      this.resizeObserver.observe(this.element);
    } else {
      this.categoriesButton?.setAttribute(
        "aria-expanded",
        String(Boolean(this.panel)),
      );
    }

    this.element.addEventListener(
      "tktWidgetB2BHeader:categories",
      this.toggleCategoriesHandler,
    );
    this.element.addEventListener("click", this.closePanelHandler);
  }

  destroy(): void {
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;

    this.element.removeEventListener(
      "tktWidgetB2BHeader:categories",
      this.toggleCategoriesHandler,
    );
    this.element.removeEventListener("click", this.closePanelHandler);
  }
}

PluginRegistry.register("tktWidgetB2B", TktWidgetB2B);
